import React, { Component } from "react";
import { BoxDanger, MnemoLoading, ModalHandler, SupportoTecnico, Title } from "components/misc";
import { networkErrorHelper } from "libs";
import { newsletterService } from "libs/api/newsletterService";
import { withRouter } from "react-router-dom";
import { Button, Container, Col, Row, Card, CardBody } from "design-react-kit";
import dayjs from "dayjs";
import { ROUTES } from "const";

class NewsletterEmailDetail extends Component {
  state = {
    loading: true,
    loadingError: false,
    emailId: 0,
    email: {},
    loadingAction: false,
  };

  componentDidMount() {
    const emailId = parseInt(this.props.match.params.emailId) > 0 ? this.props.match.params.emailId : 0;
    this.setState({ emailId });
    this.loadRemote(emailId);
  }

  goBack() {
    window.history.back();
  }

  loadRemote(emailId) {
    this.setState({ loading: true });

    newsletterService
      .getNewsletterEmail(emailId)
      .then(({ data }) => {
        const { email } = data.payload;

        this.setState({
          loading: false,
          email,
        });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({
          loading: false,
          loadingError: true,
        });
      });
  }

  onStartJob = () => {
    const { email } = this.state;
    const { subject } = email;
    const title = "Conferma avvio";
    const message = `Sei sicuro di voler avviare l'invio massivo di questa email (oggetto: ${subject})?`;

    ModalHandler.show(null, title, message, null, this.confirmStartJob);
  };

  onSuspendJob = () => {
    const title = "Conferma sospensione";
    const message = "Sei sicuro di voler sospendere l'invio? Le email attualmente in coda non verranno spedite fino a un nuovo avvio.";

    ModalHandler.show(null, title, message, null, this.confirmSuspendJob);
  };

  onExport = () => {
    const title = "Esporta email";
    const message = "Verrà esportata la lista delle email. Vuoi procedere?";

    ModalHandler.show(null, title, message, null, this.confirmExport);
  };

  onEdit = () => {
    const { emailId } = this.state;
    this.props.history.push(`${ROUTES.NEWSLETTER_EMAIL_FORM}/${emailId}`);
  };

  confirmStartJob = () => {
    const { emailId } = this.state;
    this.setState({ loadingAction: true });

    newsletterService
      .startEmailJob(emailId)
      .then(() => {
        this.loadRemote(emailId);
        this.setState({ loadingAction: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loadingAction: false });
      });
  };

  confirmSuspendJob = () => {
    const { emailId } = this.state;
    this.setState({ loadingAction: true });

    newsletterService
      .suspendEmailJob(emailId)
      .then(() => {
        this.loadRemote(emailId);
        this.setState({ loadingAction: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loadingAction: false });
      });
  };

  confirmExport = () => {
    this.setState({ loading: true });

    const { email } = this.state;

    newsletterService
      .exportEmails(email.id)
      .then(({ data }) => {
        const name = `export_newsletter_email_${email.id}_`;
        const originalName = name + dayjs().format("DD_MM_YYYY_HH_mm_ss") + ".xlsx";

        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", originalName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  calculateStats = (stats = [], sentCount = 0) => {
    const getStat = (type) => stats.find((s) => s.eventType === type) || { totalCount: 0, uniqueCount: 0 };

    //events
    const sends = getStat("Send");
    const deliveries = getStat("Delivery");
    const opens = getStat("Open");
    const bounces = getStat("Bounce");
    const complaints = getStat("Complaint");
    const rejects = getStat("Reject");
    const renderingFailures = getStat("Rendering Failure");
    const delays = getStat("DeliveryDelay");

    const base = Math.max(sentCount, 1);
    const openRate = ((opens.uniqueCount / base) * 100).toFixed(1);
    const bounceRate = ((bounces.uniqueCount / base) * 100).toFixed(1);
    const deliveryRate = ((deliveries.uniqueCount / base) * 100).toFixed(1);

    return {
      opens,
      sends,
      deliveries,
      bounces,
      complaints,
      rejects,
      renderingFailures,
      delays,
      openRate,
      bounceRate,
      deliveryRate,
    };
  };

  emailPreviewRef = React.createRef();

  resizeEmailPreview = () => {
    const iframe = this.emailPreviewRef.current;
    const document = iframe?.contentDocument;

    if (!iframe || !document) return;

    iframe.style.height = "0px";
    iframe.style.height = `${Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    )}px`;
  };

  render() {
    const { loading, loadingError, email, loadingAction } = this.state;
    const { senderEmail, senderName, subject, preview, interval, status, note, items, stats } = email;

    const { opens, openRate, bounceRate, deliveries, deliveryRate, complaints, rejects, renderingFailures, delays, bounces } = this.calculateStats(
      stats,
      items?.sent || 0,
    );

    return (
      <>
        {loading ? (
          <MnemoLoading />
        ) : loadingError ? (
          <BoxDanger className="m-5">
            Si è verificato un errore durante l'elaborazione della richiesta, se il problema persiste puoi <SupportoTecnico />
          </BoxDanger>
        ) : (
          <Container>
            <Col lg={{ size: 12 }} className="text-right">
              <Button onClick={this.goBack} color="btn btn-primary bg-dark p-3">
                Torna Indietro
              </Button>
            </Col>

            <Title>Dettaglio invio email: {subject}</Title>

            <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
              <CardBody>
                <Row className="mb-4 align-items-center">
                  <Col md="6">
                    <h4 className="mb-0 d-flex align-items-center">
                      Stato:
                      {status === "created" && <span className="text-secondary ml-2">Creato</span>}
                      {status === "queued" && <span className="text-muted ml-2">In Coda</span>}
                      {status === "inProgress" && <span className="text-primary ml-2">In Lavorazione</span>}
                      {status === "suspended" && <span className="text-warning ml-2">Sospeso</span>}
                      {status === "error" && <span className="text-danger ml-2">Errore</span>}
                      {status === "end" && <span className="text-success ml-2">Terminato</span>}
                    </h4>
                  </Col>

                  <Col md="6" className="text-right">
                    {(status === "created" || status === "suspended" || status === "error") && (
                      <Button color="success" onClick={this.onStartJob} disabled={loadingAction}>
                        {loadingAction ? "Avvio..." : "Avvia"}
                      </Button>
                    )}

                    {(status === "created" || status === "suspended") && (
                      <Button className="primary bg-dark ml-2" onClick={this.onEdit} disabled={loadingAction}>
                        Modifica
                      </Button>
                    )}

                    {(status === "queued" || status === "inProgress") && (
                      <Button color="warning" onClick={this.onSuspendJob} disabled={loadingAction}>
                        {loadingAction ? "Sospensione..." : "Sospendi"}
                      </Button>
                    )}

                    {status === "end" && (
                      <Button className="primary bg-dark" onClick={this.onExport} disabled={loadingAction}>
                        {loadingAction ? "Esportazione..." : "Esporta email"}
                      </Button>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col md="6" className="mb-2">
                    <p>
                      <strong>Mittente: </strong>
                      {senderName} &lt;{senderEmail}&gt;
                    </p>
                  </Col>
                  <Col md="6" className="mb-2">
                    <p>
                      <strong>Intervallo invio: </strong>
                      {interval < 60
                        ? `${interval} secondi`
                        : interval % 60 === 0
                          ? `${interval / 60} minuto/i`
                          : `${Math.floor(interval / 60)} min e ${interval % 60} sec`}
                    </p>
                  </Col>
                  {note && (
                    <Col md="12">
                      <p>
                        <strong>Note: </strong>
                        {note}
                      </p>
                    </Col>
                  )}
                </Row>

                <Row className="my-2">
                  <Col md="12">
                    <h4 className="pb-2">Riepilogo invio</h4>
                    <div className="p-2 rounded border shadow-sm">
                      <Row className="ml-2">
                        <Col md="3">
                          <div className="p-2">
                            <h6 className="text-muted mb-1">Totale</h6>
                            <h3 className="mb-0">{items.total}</h3>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="p-2">
                            <h6 className="text-muted mb-1">Inviate</h6>
                            <h3 className={`${items.sent > 0 ? "text-success" : ""} mb-0`}>{items.sent}</h3>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="p-2">
                            <h6 className="text-muted mb-1">Da inviare</h6>
                            <h3 className={`${items.toSend > 0 ? "text-warning" : ""} mb-0`}>{items.toSend}</h3>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="p-2">
                            <h6 className="text-muted mb-1">Fallite</h6>
                            <h3 className={`${items.error > 0 ? "text-danger" : ""} mb-0`}>{items.error}</h3>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                {items.sent > 0 && (
                  <Row className="my-4">
                    <Col md="12">
                      <h4 className="pb-2">Statistiche</h4>
                      <div className="p-3 rounded border shadow-sm">
                        <Row className="ml-2">
                          <Col md="4">
                            <h5 className="my-1">Tasso di consegna</h5>
                            <h2 className="mb-1">{deliveryRate}%</h2>
                            <small className="text-muted">
                              <strong>{deliveries.uniqueCount}</strong> consegnate
                            </small>
                          </Col>

                          <Col md="4">
                            <h5 className="my-1">Tasso di apertura</h5>
                            <h2 className="mb-1">{openRate}%</h2>
                            <small className="text-muted">
                              <strong>{opens.uniqueCount}</strong> aperte
                            </small>
                          </Col>

                          <Col md="4">
                            <h5 className="my-1">Tasso di bounce</h5>
                            <h2 className="mb-1">{bounceRate}%</h2>
                            <small className="text-muted">
                              <strong>{bounces.totalCount} </strong> respinte
                            </small>
                          </Col>
                        </Row>

                        <hr />

                        <Row className="ml-2">
                          <Col md="3" className="mb-0">
                            <span className="text-muted d-block small">Rifiutate</span>
                            <h4 className={rejects.totalCount > 0 ? "text-danger" : ""}>{rejects.totalCount}</h4>
                          </Col>
                          <Col md="3" className="mb-0">
                            <span className="text-muted d-block small">Errori di rendering</span>
                            <h4 className={renderingFailures.totalCount > 0 ? "text-danger" : ""}> {renderingFailures.totalCount}</h4>
                          </Col>
                          <Col md="3" className="mb-0">
                            <span className="text-muted d-block small">Segnalazioni spam</span>
                            <h4 className={complaints.totalCount > 0 ? "text-danger" : ""}>{complaints.totalCount}</h4>
                          </Col>
                          <Col md="3" className="mb-0">
                            <span className="text-muted d-block small">Ritardi di consegna</span>
                            <h4 className={delays.totalCount > 0 ? "text-danger" : ""}>{delays.totalCount}</h4>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row className="my-4">
                  <Col md="12">
                    <h4 className="pb-2">Anteprima email</h4>
                    <div className="border rounded p-2 shadow-sm">
                      <iframe
                        ref={this.emailPreviewRef}
                        title="Anteprima Email"
                        srcDoc={preview}
                        onLoad={this.resizeEmailPreview}                   
                        style={{
                          width: "100%",
                          border: "none",
                          display: "block",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        )}
      </>
    );
  }
}

export default withRouter(NewsletterEmailDetail);
